export default __webpack_public_path__ + "static/media/Acie.cf77e99d.png";